function init() {

    $(window).scroll( function() {
        if ($(window).width() <= '575'){
            if ( $(this).scrollTop() > 158) {
                $('body').addClass('sticky-filter');
            } else {
                $('body').removeClass('sticky-filter');
            }
        }
    });
}

module.exports = {
    init: init
};